/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { chatLoad } from "../funcs/chatLoad.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Chat } from "../models/components/chat.js";
import {
  LoadChatRequest,
  LoadChatSecurity,
} from "../models/operations/loadchat.js";
import { unwrapAsync } from "../types/fp.js";
export type LoadChatQueryData = Chat;

export function prefetchLoadChat(
  queryClient: QueryClient,
  client$: GramCore,
  request: LoadChatRequest,
  security?: LoadChatSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildLoadChatQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildLoadChatQuery(
  client$: GramCore,
  request: LoadChatRequest,
  security?: LoadChatSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<LoadChatQueryData>;
} {
  return {
    queryKey: queryKeyLoadChat({
      id: request.id,
      generation: request.generation,
      limit: request.limit,
      beforeSeq: request.beforeSeq,
      afterSeq: request.afterSeq,
      fromStart: request.fromStart,
      riskOnly: request.riskOnly,
      query: request.query,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
      gramChatSession: request.gramChatSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function loadChatQueryFn(ctx): Promise<LoadChatQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(chatLoad(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyLoadChat(
  parameters: {
    id: string;
    generation?: number | undefined;
    limit?: number | undefined;
    beforeSeq?: number | undefined;
    afterSeq?: number | undefined;
    fromStart?: boolean | undefined;
    riskOnly?: boolean | undefined;
    query?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
    gramChatSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "chat", "load", parameters];
}
